import type {FC} from 'react';
import type {TaskDefinitionRequest} from 'src/api/ProactApiClient';
import {PendingSyncBanner} from 'src/offline/PendingSyncBanner';
import type {PendingSyncBannerCopy} from 'src/offline/PendingSyncBanner';
import type {OutboxItem} from 'src/offline/types';
import {actionCreateCascade, taskTransitionCascade} from './outboxActions';
import {TASK_OUTBOX_KINDS} from './outboxKinds';
import {usePendingTaskItems} from './usePendingTaskItems';

const itemLabel = (item: OutboxItem): string =>
  item.kind === TASK_OUTBOX_KINDS.create
    ? (item.payload as TaskDefinitionRequest).subject || 'New action'
    : 'Task update';

const cascadeFor = (item: OutboxItem) =>
  item.kind === TASK_OUTBOX_KINDS.create
    ? actionCreateCascade
    : taskTransitionCascade;

const COPY: PendingSyncBannerCopy = {
  noun: 'task update',
  nounPlural: 'task updates',
  offlineTail: 'They will be sent automatically when you are back online.',
  discardTitle: 'Discard this update?',
  discardBodyTail: 'it will not be sent.',
  discardConfirmLabel: 'Discard update',
};

// Shown on the task and action surfaces while queued task work sits unsynced.
export const TasksPendingSyncBanner: FC = () => {
  const {pendingCount, failedItems} = usePendingTaskItems();

  return (
    <PendingSyncBanner
      pendingCount={pendingCount}
      failedItems={failedItems}
      itemLabel={itemLabel}
      onRetry={item => cascadeFor(item).retry(item)}
      onDiscard={item => cascadeFor(item).discard(item)}
      copy={COPY}
    />
  );
};
